import { FormattedMessage } from '@futrli/localisation';
import { AmplifyException } from '@futrli/shared-services';
import React from 'react';

import { AuthError } from '../core/types';
import {
  INVITATION_BUSINESS_TYPE_STORAGE_KEY,
  INVITATION_INVITE_REFERENCE_STORAGE_KEY,
  INVITATION_LANDING_URL_STORAGE_KEY,
  INVITATION_SOURCE_STORAGE_KEY,
  INVITATION_WORKSPACE_ID_STORAGE_KEY
} from '../storage/constants';
import { Storage } from '../storage/storage';

export const storeInvitationData = (
  landingPath: string,
  workspaceId: string,
  inviteReference?: string,
  inviteSource?: 'sales' | 'predict',
  businessType?: string
) => {
  const storage = Storage.getInstance();

  storage.set(INVITATION_WORKSPACE_ID_STORAGE_KEY, workspaceId);
  storage.set(INVITATION_LANDING_URL_STORAGE_KEY, landingPath);
  storage.set(INVITATION_INVITE_REFERENCE_STORAGE_KEY, inviteReference || '');
  storage.set(INVITATION_SOURCE_STORAGE_KEY, inviteSource || '');
  storage.set(INVITATION_BUSINESS_TYPE_STORAGE_KEY, businessType || '');
};

export const removeInvitationData = () => {
  const storage = Storage.getInstance();

  storage.remove(INVITATION_WORKSPACE_ID_STORAGE_KEY);
  storage.remove(INVITATION_LANDING_URL_STORAGE_KEY);
  storage.remove(INVITATION_INVITE_REFERENCE_STORAGE_KEY);
  storage.remove(INVITATION_SOURCE_STORAGE_KEY);
  storage.remove(INVITATION_BUSINESS_TYPE_STORAGE_KEY);
};

export const getInvitationBusinessType = () => {
  return Storage.getInstance().get(INVITATION_BUSINESS_TYPE_STORAGE_KEY, '');
};

export const getInvitationWorkspace = () => {
  return Storage.getInstance().get(INVITATION_WORKSPACE_ID_STORAGE_KEY, '');
};

export const getInvitationInviteReference = () => {
  return Storage.getInstance().get(INVITATION_INVITE_REFERENCE_STORAGE_KEY, '');
};

export const getInvitationSource = () => {
  return Storage.getInstance().get(INVITATION_SOURCE_STORAGE_KEY, '');
};

export const removeInvitationWorkspace = () => {
  Storage.getInstance().remove(INVITATION_WORKSPACE_ID_STORAGE_KEY);
};

export const getInvitationLandingPath = () => {
  return Storage.getInstance().get(INVITATION_LANDING_URL_STORAGE_KEY, '');
};

export const getInviteErrorMessage = (inviteError?: AuthError) => {
  if (inviteError?.code === AmplifyException.NotAuthorized) {
    return (
      <FormattedMessage
        id="invite.invitation_no_longer_valid"
        defaultMessage="Oops, this invitation is no longer valid. Please log in to your account or contact an administrator to get a new invitation."
      />
    );
  }

  return inviteError?.message;
};
